<template>
    <div style="width: 100%;height: 30px;font-size: 14px">
        <v-layout row class="ma-0">
            <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px">图标大小</div>
            <div style="width: 86px;height: 30px;margin-left: 75px;" >
<!--                <v-select-->
<!--                        v-model="sizeSelect"-->
<!--                        :items="markerSizeList"-->
<!--                        item-text="name"-->
<!--                        :attach="true"-->
<!--                        item-value="size"-->
<!--                        height="30"-->
<!--                        dark-->
<!--                        background-color="rgba(56, 56, 56, 1)"-->
<!--                        dense-->
<!--                        outlined-->
<!--                        hide-details-->
<!--                        style="font-size: 14px"-->
<!--                        :menu-props="{ bottom: true, offsetY: true,dark:true}"-->
<!--                        class="sizePicker"-->
<!--                >-->
<!--                    <template v-slot:item="{item}">-->
<!--                        <div style="width: 60px;text-align: center;height: 28px;line-height: 28px;font-size: 14px">{{item.name}}</div>-->
<!--                    </template>-->
<!--                </v-select>-->
                <el-select v-model="sizeSelect" :popper-append-to-body="false" size="small" style="width: 86px" class="select_el">
                    <el-option
                            v-for="item in markerSizeList"
                            :key="item.size"
                            :label="item.name"
                            :value="item.size">
                    </el-option>
                </el-select>
            </div>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "SizePicker",
        props:["currSize"],
        data(){
            return{
                sizeSelect:this.currSize,
                color:'#20518A',
                markerSizeList:[
                    {name:'小',size:0.6,},
                    {name:'中',size:0.8,},
                    {name:'大',size:1,},
                ],
            }
        },
        watch:{
            sizeSelect(){
                this.$emit("changeSize",this.sizeSelect)
            }
        }
    }
</script>

<style >
    .sizePicker .v-input__slot{
        min-height: 30px !important;
    }
    .sizePicker .v-sheet.v-list{
        background: rgba(56, 56, 56, 1) !important;
    }

    /*elemeng UI 的select组件样式修改*/
    .select_el .el-input__inner{
        color:white !important;
        font-size: 14px !important;
        padding: 0 20px 0 10px !important;
        background-color: rgba(56, 56, 56, 1) !important;
        /*height: 30px !important;*/
    }
    .select_el .el-select-dropdown{
        background-color:  rgba(56, 56, 56, 1) !important;
        width: 86px !important;
        margin-top: 5px !important;
    }

    .select_el .el-select-dropdown__item{
        color: white !important;
        text-align: center !important;
    }
    .select_el .el-select-dropdown__item.hover,.el-select-dropdown__item:hover{
        background-color: rgba(32, 81, 138, 1) !important;
    }
    .select_el .el-select-dropdown__list{
        padding: 5px 0 !important;
    }
    .select_el .el-popper .popper__arrow{

    }

</style>
